import { extend } from 'sk-ui/lib/utils/util.js'

import deliveryGuideForm from './metaData/deliveryGuideForm'

export default {
  GuideCreate({ commit }, params) {
    const props = {}
    const createForm = extend(true, {}, deliveryGuideForm)
    this.dispatch('OpenFullDialog', {
      metaData: createForm,
      props
    })
  },

  GuideEdit({ commit }, params) {
    const props = {
      title: '编辑指导配置',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, deliveryGuideForm)
    editForm.needFetchFillInfo = true
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
